import { componentLabel } from '../utils/editor';
import blockIcon from './icons/block.svg';

export const loadBlock = (editor, options) => {
  const { componentType, blockCategory, label } = options;

  editor.BlockManager.add(componentType, {
    label: componentLabel(label, blockIcon),
    category: blockCategory,
    activate: true,
    select: true,
    content: {
      type: componentType,
    },
  });
};
